import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function TableHeading(props) {
    function handleClick(event) {
        if (props.sortLink && !event.target.closest('.sales__catalogueRefineLotsEntriesWrp')) {
            props.onSort(props.filterBy ? props.filterBy : props.columnName, props.sortLink);
        }
    }

    return (
        <th
            className={classNames(
                'ui-table__cell',
                { 'ui-table__cell_sorted': props.sortOrder === 1 },
                props.headerClassName
            )}
            onClick={handleClick}
            {...props.headerDataAttrs}
            {...props.options}
        >
            {(() => {
                if (props.customHeader) {
                    const CustomHeader = (props.customHeader.component)
                        ? props.customHeader.component
                        : props.customHeader;

                    return (
                        <span>
                            <CustomHeader
                                {...props.customHeader.options}
                                isSelected={props.isSelected}
                                onSelect={props.onRowsSelect}
                            />
                        </span>
                    );
                }
                return (
                    <span>
                        <span>
                            <span>{props.displayName}</span>
                        </span>
                    </span>
                );
            })()}
        </th>
    );
}

TableHeading.propTypes = {
    displayName: PropTypes.string,
    headerClassName: PropTypes.string,
    headerDataAttrs: PropTypes.object,
    customHeader: PropTypes.object,
    columnName: PropTypes.string,
    filterBy: PropTypes.string,
    sortLink: PropTypes.any,
    sortOrder: PropTypes.number,
    onSort: PropTypes.func,
    options: PropTypes.object,
    /**
     * On row select event handler
     */
    onRowsSelect: PropTypes.func,
    /**
     * Is row selected
     */
    isSelected: PropTypes.bool
};

export default TableHeading;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableHeading.js